/**
 * 「我的」接口：GET /me、PUT /me/profile、GET /me/export、DELETE /me。
 */
import { api } from './client.js';
import type { ExportBundleDto, MeDto, ProfileDto, ProfilePayload } from './types.js';

export const meApi = {
  /** 当前用户 + 画像（无画像时 profile 为 null） */
  get: (): Promise<MeDto> => api.get<MeDto>('/me'),

  /** 保存画像（字段与 shared 的 validateProfile 一致） */
  updateProfile: (input: ProfilePayload): Promise<{ profile: ProfileDto }> =>
    api.put<{ profile: ProfileDto }>('/me/profile', input),

  /** 合规：导出我的全部数据（前端直接序列化成 JSON 下载） */
  exportData: (): Promise<ExportBundleDto> => api.get<ExportBundleDto>('/me/export'),

  /** 合规：删除账号（软删 + 撤销 refresh token）→ 204 */
  deleteAccount: (): Promise<void> => api.delete<void>('/me'),
};